:host {
    display: block;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }
}

.button {
    border: 1px solid var(--ux-button-primary-bg-color);
    border-radius: 100px;
    cursor: pointer;
    font-family: "Frutiger-Bold", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    display: inline-block;
    background: transparent;
    transition:
        width 0.25s ease,
        height 0.25s ease;
    font-size: 15px;
    padding: 1px;

    // the calculated width for desktop is set via style attribute, so we need to override it here
    @media screen and (max-width: calc($desktop-s - 1px)) {
        width: 42px !important;
    }

    @media screen and (max-width: calc($tablet - 1px)) {
        width: 30px !important;
    }

    @media only screen and (min-width: $tablet) {
        font-size: 19px;
        padding: 2px;
    }

    @media only screen and (min-width: $desktop-s) {
        font-size: 23px;
        padding: 3px;
    }

    &:not(:hover) {
        @media only screen and (min-width: $desktop-s) {
            width: 50px !important;
        }
    }

    &--active {
        animation: pulse 5s infinite;

        &:not(:hover) .button__inner {
            background: var(--ux-button-primary-bg-color);
            color: var(--ux-button-primary-text-color);
        }
    }

    &__inner {
        display: block;
        background: var(--ux-button-primary-text-color);
        width: 100%;
        position: relative;
        border-radius: 50px;
        color: var(--ux-button-primary-bg-color);
        border: 1px solid var(--ux-button-primary-bg-color);
        transition:
            background 0.25s ease,
            color 0.25s ease,
            width 0.25s ease;
        overflow: hidden;
        height: 26px;
        padding-top: 3px;

        @media only screen and (min-width: $tablet) {
            height: 36px;
            padding-top: 4px;
            border-width: 2px;
        }

        @media only screen and (min-width: $desktop-s) {
            height: 42px;
            padding-top: 6px;
        }
    }
}

.button:hover {
    z-index: 1;

    @media only screen and (min-width: $desktop-s) {
        .label {
            opacity: 0;
        }

        .title {
            opacity: 1;
        }
    }

    @media screen and (max-width: calc($desktop-s - 1px)) {
        .button__inner {
            background: var(--ux-button-primary-bg-color);
            color: var(--ux-button-primary-text-color);
        }
    }
}

// when the hot spot has an icon, the button needs to be larger
.button--icon {
    font-size: 36px;

    // the calculated width for desktop is set via style attribute, so we need to override it here
    @media screen and (max-width: calc($desktop-s - 1px)) {
        width: 64px !important;
        height: 64px;
    }

    @media screen and (max-width: calc($tablet - 1px)) {
        font-size: 26px;
        width: 48px !important;
        height: 48px;
    }

    @media only screen and (min-width: $desktop-s) {
        font-size: 43px;
        height: 80px;

        &:not(:hover) {
            width: 80px !important;
        }
    }

    .button__inner {
        height: 44px;

        @media only screen and (min-width: $tablet) {
            height: 58px;
            padding-top: 4px;
        }

        @media only screen and (min-width: $desktop-s) {
            height: 72px;
            padding-top: 6px;
        }
    }

    .label {
        left: 21px;

        @media only screen and (min-width: $tablet) {
            left: 27px;
        }

        @media only screen and (min-width: $desktop-s) {
            left: 34px;
        }
    }

    .title {
        transform: translateY(-5px);
    }
}

.button--no-title:hover {
    .label {
        opacity: 1;
    }

    .button__inner {
        background: var(--ux-button-primary-bg-color);
        color: var(--ux-button-primary-text-color);
    }
}

.label {
    transition: opacity 0.25s ease;
    position: absolute;
    transform: translateX(-50%);
    left: 12px;

    @media only screen and (min-width: $tablet) {
        left: 16px;
    }

    @media only screen and (min-width: $desktop-s) {
        left: 19px;
    }

    &--icon {
        margin-top: 0;

        @media only screen and (min-width: $tablet) {
            margin-top: -1px;
        }

        @media only screen and (min-width: $desktop-s) {
            margin-top: -2px;
        }
    }

    &--bullet {
        width: 100%;
        display: inline-block;
    }

    &--bullet::before {
        content: "•";
        text-align: center;
        width: 100%;
        display: inline-block;
        font-size: 1.4em;
        transform: translateY(-3px);

        @media only screen and (min-width: $tablet) {
            transform: translateY(-4px);
        }

        @media only screen and (min-width: $desktop-s) {
            transform: translateY(-5px);
        }
    }
}

.title {
    display: inline-block;
    font-family: "Frutiger-Roman", sans-serif;
    opacity: 0;
    transition: opacity 0.25s ease;
    color: $color-black;
    font-size: 16px;
    transform: translateY(-3px);
    white-space: nowrap;
    margin: 0 20px;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 var(--ux-button-primary-bg-color);
    }

    50% {
        box-shadow: 0 0 30px var(--ux-button-primary-bg-color);
    }

    100% {
        box-shadow: 0 0 0 var(--ux-button-primary-bg-color);
    }
}
